import React from 'react'
import ReactDOM from 'react-dom'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbreact/dist/css/mdb.css'
import '@trendmicro/react-sidenav/dist/react-sidenav.css'
import './assets/styles/index.scss'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))
